module.exports = __webpack_public_path__ + "img/nav-right-with-contact-chevy.596b3502.png";